<template>
  <a-card class="cardMain"
          :tab-list="tabList"
          :active-tab-key="activeKey"
          @tabChange="(key: any) => onTabChange(key, 'key')">
    <template #customTab="item">
      <span v-if="item.key === 'role'">
        {{ item.tab }}
      </span>
    </template>
    <keep-alive>
      <Role v-if="activeKey == 'role'"></Role>
      <User v-else-if="activeKey == 'user'"></User>
      <Position v-else-if="activeKey == 'position'"></Position>
      <organization v-else-if="activeKey == 'organization'"></organization>
      <Detail v-else-if="activeKey == 'detailed'"></Detail>
      <AdjustPrice v-else-if="activeKey == 'adjustPrice'"></AdjustPrice>
    </keep-alive>
  </a-card>
</template> 

<script setup lang="ts">
import { message } from 'ant-design-vue'
import { onMounted, reactive, ref } from 'vue'
import { useRbacStore } from '../../DefaultRbacPagePlugin'
import Detail from './UserViewRightMenuDetailed.vue'
import organization from './UserViewRightMenuOrganization.vue'
import Position from './UserViewRightMenuPosition.vue'
import Role from './UserViewRightMenuRole.vue'
import User from './UserViewRightMenuUser.vue'
import AdjustPrice from './UserViewRightMenuAdjustPrice.vue'
const activeKey = ref('role')
const rbac = useRbacStore()
const tabList = reactive([{
  key: 'role',
  tab: '角色',
}, {
  key: 'organization',
  tab: '组织'
}, {
  key: 'position',
  tab: "职位"
}, {
  key: 'detailed',
  tab: '详细信息',
}, {
  key: 'adjustPrice',
  tab: '调价',
}])

onMounted(() => {
})
const onTabChange = (value: string, type: string) => {
  if (type === 'key' && rbac.$state.models.user.length > 0) {
    activeKey.value = value
  } else message.warning('请选择用户')
}


</script>

<style lang="less" scoped>
.cardMain {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

:deep(.ant-card-body) {
  height: 90%;
  overflow-y: auto
}
</style>
